export const CY: Record<string, string> = {
  "Home": "Cartref",
  "Resource Selected": "Adnodd Wedi'i Ddewis",
  "Resources List": "Rhestr Adnoddau",
  "List": "Rhestr",
  "Resources": "Adnoddau",
  "Find Colleague": "Dod o Hyd i Gydweithiwr",
  "Settings": "Gosodiadau",
  "Floor Plan": "Cynllun Llwyfan",
  "Locations": "Lleoedd",
  "Categories": "Categorïau",
  "Search resource name...": "Chwilio enw adnodd...",
  "Calendar": "Calendr",
  "View Details": "Gweld Manylion",
  "Add to My Favorites": "Ychwanegu at Fy Hoffethau",
  "Remove": "Dileu",
  "Resource calendar": "Calendr adnodd",
  "Today": "Heddiw",
  "Previous month": "Mis blaenorol",
  "Next month": "Mis nesaf",
  "Previous year": "Blwyddyn flaenorol",
  "Next year": "Blwyddyn nesaf",
  "Close": "Cau",
  "Field is required.": "Mae angen maes.",
  "Invalid date format.": "Fformat dyddiad annilys.",
  "S": "Sul",
  "M": "Llun",
  "T": "Maw",
  "W": "Mer",
  "F": "Gwe",
  "January": "Ionawr",
  "February": "Chwefror",
  "March": "Mawrth",
  "April": "Ebrill",
  "May": "Mai",
  "June": "Mehefin",
  "July": "Gorffennaf",
  "August": "Awst",
  "September": "Medi",
  "October": "Hydref",
  "November": "Tachwedd",
  "December": "Rhagfyr",
  "Jan": "Ion",
  "Feb": "Chwe",
  "Mar": "Maw",
  "Apr": "Ebr",
  "Jun": "Meh",
  "Jul": "Gor",
  "Aug": "Awst",
  "Sep": "Med",
  "Oct": "Hyd",
  "Nov": "Tach",
  "Dec": "Rhag",
  "st": "ain",
  "nd": "ail",
  "rd": "ydd",
  "th": "ed",
  "Sunday": "Dydd Sul",
  "Monday": "Dydd Llun",
  "Tuesday": "Dydd Mawrth",
  "Wednesday": "Dydd Mercher",
  "Thursday": "Dydd Iau",
  "Friday": "Dydd Gwener",
  "Saturday": "Dydd Sadwrn",
  "Sun": "Sul",
  "Mon": "Llun",
  "Tue": "Maw",
  "Wed": "Mer",
  "Thu": "Iau",
  "Fri": "Gwe",
  "Sat": "Sad",
  "Su": "Sul",
  "Mo": "Llun",
  "Tu": "Maw",
  "We": "Mer",
  "Th": "Iau",
  "Fr": "Gwe",
  "Sa": "Sad",
  "PM": "YP",
  "AM": "YB",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Ni allwch archebu'r adnodd hwn gan fod eich cais cyfarfod yn gwrthdaro â pholisïau archebu'r adnodd.",
  "You need permissions to interact with this resource.":
    "Mae angen caniatâd arnoch i ryngweithio â'r adnodd hwn.",
  "Reason": "Rheswm",
  "The resource cannot be booked {{day}} days in advanced.":
    "Ni ellir archebu'r adnodd hwn {{day}} diwrnod ymlaen llaw.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "Ni all dyddiad gorffen cyfarfod ailadroddol fod mwy na {{day}} diwrnod o heddiw.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Ni all hyd cyfarfod fod yn hirach na {{time}} munud.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Ni all hyd cyfarfod fod yn fyrach na {{time}} munud.",
  "Booking policy": "Polisi archebu",
  "Available": "Ar Gael",
  "Selected": "Dewiswyd",
  "Booked": "Wedi'i Archebu",
  "Closed": "Wedi'i Gau",
  "Filter Options": "Dewisiadau Hidlo",
  "{{resource}} is deleted": "Dilëwyd {{resource}}.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Gellir archebu'r adnodd hwn, ond ni fydd unrhyw achlysuron â gwrthdaro'n cael eu harchebu.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Gellir archebu'r adnodd hwn ymlaen llaw am uchafswm o {{day}} diwrnod, ni fydd unrhyw achlysuron y tu hwnt i'r terfyn hwnnw'n cael eu harchebu",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Gellir archebu'r adnodd hwn, ond rhaid i hyd y cyfarfod fod o leiaf {{time}} munud.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Gellir archebu'r adnodd hwn, ond ni ddylai hyd y cyfarfod fod yn fwy na {{time}} munud.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Mae archebu'r adnodd hwn yn gofyn am gymeradwyaeth gan gynrychiolydd yr adnodd. Bydd eich cais yn cael ei bwrw ymlaen, gan aros am gymeradwyaeth.",
  "Resource Name": "Enw'r Adnodd",
  "Description": "Disgrifiad",
  "Resource Mail": "E-bost yr Adnodd",
  "Location": "Lleoliad",
  "Capacity": "Capasiti",
  "Language": "Iaith",
  "Select an language": "Dewiswch iaith",
  "Date/Time Format": "Fformat Dyddiad/Amser",
  "First day of the week": "Cyntaf diwrnod yr wythnos",
  "Please select a first day": "Dewiswch ddiwrnod cyntaf",
  "Please select a time format": "Dewiswch fformat amser",
  "Date Format": "Fformat Dyddiad",
  "Please select a date format": "Dewiswch fformat dyddiad",
  "Date Separator": "Holltiwr Dyddiad",
  "Please select a date separator": "Dewiswch holltiwr dyddiad",
  "Apply": "Gweithredu",
  "Default Location": "Lleoliad Ragosodedig",
  "Clear": "Clirio",
  "Help": "Help",
  "UnAvailable": "Ddim ar Gael",
   "No data available": "Dim data ar gael",
    "More": "Mwy",
  "Available Floor Plans": "Cynlluniau Llwyfan Ar Gael",
  "Default Categories": "Categorïau Ragosodedig",
  "List more Resources": "Rhestru mwy o Adnoddau",
  "Attendees": "Ymwelwyr",
  "Click on Further information to visit our support site": "Cliciwch ar Ragor o Wybodaeth i ymweld â'n gwefan gefnogi",
  "New Order": "Trefn Newydd",
  "Save default categories successfully": "Methu cronfa ddata",
      "Save config date/time successfully": "Nid yw'r ddyddiad/amser yn cael ei gadw",
      "Save language successfully": "Nid yw'r iaith yn cael ei chadw",
      "Save default location successfully": "Nid yw'r lleoliad diofyn yn cael ei gadw",
      "And": "A",
  "Or": "Neu",
  "Available occurrences of the series": "Darpariaethau ar gael o'r gyfres",
  "Conflicting Occurrences": "Digwyddiadau Gwrthdaro",
  "Availability": "Argaeledd",
  "Time Format": "Fformat Amser",
  "You do not have permission to book this resource.": "Nid oes gennych ganiatâd i archebu'r adnodd hwn.",
"This resource does not allow booking of recurring meetings.": "Nid yw'r adnodd hwn yn caniatáu archebu cyfarfodydd amlblygadwy.",
"You cannot book this resource.": "Ni allwch archebu'r adnodd hwn."
};
